import { CHANNELS_FETCH_SUCCESS } from 'common/actions/channels';

const initialState = [];

export const channelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANNELS_FETCH_SUCCESS:
      return action.payload.channels;

    default:
      return state;
  }
};
